'use client';

import { useEffect, useState } from 'react';
import { SkillItem } from '@wishket/design-system';

import {
  useCollectionHashTagQuery,
  useCollectionKeywordQuery,
} from '@/entities/collection';

const useCollectionTagAutoComplete = ({ enabled }: { enabled: boolean }) => {
  const [tagQuery, setTagQuery] = useState<string>('');
  const [selectedTag, setSelectedTag] = useState<string[]>([]);
  const [staticTagItems, setStaticTagItems] = useState<SkillItem[]>([]);

  const { data: staticTagData } = useCollectionKeywordQuery({
    enabled,
  });
  const { data: searchedTagData } = useCollectionHashTagQuery({
    enabled,
    q: tagQuery,
    selected: selectedTag.toString(),
  });

  const handleTagDelete = (item: string) => {
    setSelectedTag(
      selectedTag.filter(
        (selectedItem) => selectedItem.toLowerCase() !== item.toLowerCase()
      )
    );
  };

  const handleTagInput = (value: string) => {
    setSelectedTag((prev) => Array.from(new Set([...prev, value])));
    setTagQuery('');
  };

  useEffect(() => {
    if (staticTagData) {
      setStaticTagItems(
        staticTagData.filter(
          (tag) =>
            tag.value.toLowerCase().startsWith(tagQuery.toLowerCase()) &&
            !selectedTag.includes(tag.value)
        )
      );
    }
  }, [tagQuery, staticTagData, selectedTag]);

  return {
    tagQuery,
    selectedTag,
    staticTagItems,
    searchedTagData,
    setTagQuery,
    setSelectedTag,
    handleTagInput,
    handleTagDelete,
  };
};

export default useCollectionTagAutoComplete;
